<template>
  <div>
    <b-form class="padding">
      <b-row>
        <b-col></b-col>
        <b-col cols="7">
          <b-card class="card-border">
            <b-card-title style="text-align: center"><h3>{{$t('msg.troubleshooting')}}</h3></b-card-title>
            <b-card-body>
              <div>
                <b-row>
                  <b-col cols="12" class="text-justify padding-border">
                    <h5>{{$t('msg.troubleshooting_header_text')}}</h5>
                    <ul style="list-style-type: decimal;">
                      <li>
                        <p>{{$t('msg.troubleshooting_body_point_1_text')}}</p>
                      </li>
                      <li>
                        {{$t('msg.troubleshooting_body_point_2_text')}}
                        <ul style="list-style-type: square; margin-left: -2%">
                          <li>
                            {{$t('msg.troubleshooting_body_point_2_child_1_text')}}
                          </li>
                          <li>
                            <p>{{$t('msg.troubleshooting_body_point_2_child_2_text')}}</p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <p>{{$t('msg.troubleshooting_body_point_3_text')}}</p>
                      </li>
                      <li>
                        <p>
                          {{$t('msg.troubleshooting_body_point_4_text')}}
                        </p>
                      </li>
                      <li>
                        <p>
                          {{$t('msg.troubleshooting_body_point_5_text')}}
                        </p>
                      </li>
                    </ul>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
            <div style="text-align: center; padding: 2%">
              <b-button variant="primary" href="/">{{$t('msg.back_to_login')}}</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "Troubleshooting"
}
</script>

<style scoped>
.padding {
  padding: 5% 2% 2%;
}

.padding-border {
  padding: 2%;
}

.card-border {
  box-shadow: 1px 2px 10px -1px;
  background: rgba(255, 255, 255, .75);
}

</style>
